import { ReactNode } from "react";

import { RequiredAsterisk } from "src/base-components/RequiredAsterisk";

export const Label: React.FC<{
  children?: ReactNode;
  required?: boolean;
  mb?: `mb-${number}`;
}> = ({ children, required, mb = "mb-2" }) => (
  <label
    className={`inline-block font-inter-semibold-13px text-gray-800 ${mb}`}
    data-record="true"
  >
    {children} {required && <RequiredAsterisk />}
  </label>
);
